/**
 * Move type (A1) — the ONE place that decides whether a lead is long distance.
 *
 * `leads.move_type` is free text; the UI offers 'Long Distance Relocation' and
 * 'Local Move'. Before A1 this substring test was copied into two files
 * (BillingSections and the contractor-estimate route). Accessorials are long
 * distance ONLY, so this predicate now decides what a client is billed — two
 * copies of it was a divergence waiting to bill someone wrongly.
 *
 * Kept as a substring match rather than an equality check because the stored
 * strings are historical free text and an exact comparison would silently
 * reclassify older leads as local, quietly removing their accessorials.
 */
export function isLongDistance(lead: { move_type?: string | null } | null | undefined): boolean {
  return String(lead?.move_type ?? '').toLowerCase().includes('long distance');
}
